var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs8: "", "offset-xs2": "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-container",
                [
                  _c("h1", { staticClass: "display-1" }, [
                    _vm._v("JSON File Upload")
                  ]),
                  _vm._v(" "),
                  _c("v-textarea", {
                    attrs: { label: "Paste JSON here" },
                    model: {
                      value: _vm.upload,
                      callback: function($$v) {
                        _vm.upload = $$v
                      },
                      expression: "upload"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: {
                        loading: _vm.loading,
                        disabled: _vm.loading,
                        color: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.uploadCustomers()
                        }
                      }
                    },
                    [
                      _vm._v("\n        Upload\n          "),
                      _c("v-icon", { attrs: { right: "", dark: "" } }, [
                        _vm._v("cloud_upload")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59e78d9b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59e78d9b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/import/Customers.vue
// module id = null
// module chunks = 